import { useSentPage } from "./logic";
import { SentPageTemplate } from "./template";

export const SentPage = (): JSX.Element => {
  const data = useSentPage();
  return <SentPageTemplate {...data} />;
};
